"use strict";

export default class ProfileFiltersService {
    constructor(http, backendUrl) {
        this.http = http;
        this.backendUrl = backendUrl;
    }

    async getSavedSettings() {
        return this.http.get(`${this.backendUrl}/filters`).then((response) => {
            const {data} = response;
            return {
                jqlFilterText: data.filtersSynchronization.jqlFilterText,
                wiqlFilterText: data.filtersSynchronization.wiqlFilterText,
                jiraFilteringEnabled: data.filtersSynchronization.jiraFilteringEnabled,
                azureFilteringEnabled: data.filtersSynchronization.azureFilteringEnabled,
                jqlAppendix: data.jqlAppendix,
                wiqlAppendix: data.wiqlAppendix,
            }

        });
    }

    async saveSettings(settings) {
        return this.http.post(`${this.backendUrl}/filters`, settings)
    }

    async testQuery({type, query}) {
        return this.http.post(`${this.backendUrl}/filters/test`, {type, query}).then(response => {
            return {
                success: response.data.success,
                count: response.data.total,
                url: response.data.url,
                reason: response.data.reason
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/service/profileFilters.js